import callApi from './callApi';
export const fetchAPIToken = (projectId) => {
  const url = `projects/get-api-token?projectId=${projectId}`;
  return callApi(url, {}, 'GET');
}

export const generateAPIToken = (projectId) => {
  const url = `projects/generate-api-token?projectId=${projectId}`;
  return callApi(url, {}, 'GET');
}

export const addJenkinsDetails = (data, projectId) => {
  const url = `projects/add-jenkins-details?projectId=${projectId}`;
  return callApi(url, {}, 'PUT', data);
}

export const addGithubActionsDetails = (data, projectId) => {
  const url = `projects/add-github-details?projectId=${projectId}`;
  return callApi(url, {}, 'PUT', data);
}

export const getJenkinsJobs = (projectId) => {
  const url = `projects/get-jenkins-jobs?projectId=${projectId}`;
  return callApi(url, {}, 'GET');
}

export const triggerJenkinsJob = (data) => {
  const url = `projects/automation/trigger-jenkins-build`;
  return callApi(url, {}, 'POST', data);
}

export const triggerGithubWorkflow = (data) => {
  const url = `projects/automation/trigger-github-workflow`;

  return callApi(url, {}, 'POST', data);
}

export const updateIterationWorkflow = (data) => {
  const url = `projects/iterations/update-iteration-workflow`;

  return callApi(url, {}, 'PUT', data);
}

export const checkBuildStatusGithub = (testCycleId, activeTab, jobName, projectId) => {
  const url = `projects/automation/check-workflow-status?testCycleId=${testCycleId}&iteration=${activeTab}&jobName=${jobName}&projectId=${projectId}`;

  return callApi(url, {}, 'PUT');
}

export const checkBuildStatusJenkins = (testCycleId, activeTab, jobName, projectId) => {
  const url = `projects/automation/check-build-status?testCycleId=${testCycleId}&iteration=${activeTab}&jobName=${jobName}&projectId=${projectId}`;

  return callApi(url, {}, 'PUT');
}

export const abortWorkflow = (data) => {
  const url = `projects/automation/abort-workflow`;

  return callApi(url, {}, 'PUT', data);
}

export const abortBuild = (data) => {
  const url = `projects/automation/stop-build`;

  return callApi(url, {}, 'PUT', data);
}